import * as React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useCopyAnimatedStyles } from './CopyAnimated.styles';
const SvgCopyAnimated = (props)=>{
    const classes = useCopyAnimatedStyles();
    const [animState, setAnimState] = React.useState(0);
    const onMouseEnter = React.useCallback(()=>{
        setAnimState(1);
    }, [
        setAnimState
    ]);
    const onMouseLeave = React.useCallback(()=>{
        setAnimState(2);
    }, [
        setAnimState
    ]);
    return /*#__PURE__*/ React.createElement("span", {
        className: mergeClasses(classes.copyIcon),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 40 40",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("rect", {
        className: mergeClasses(classes.backgroundRect, animState === 1 && classes.backgroundRectOver, animState === 2 && classes.backgroundRectOut),
        x: "4",
        y: "12",
        rx: "6",
        ry: "6",
        width: "26",
        height: "22"
    }), /*#__PURE__*/ React.createElement("rect", {
        className: mergeClasses(classes.outlineRect, animState === 1 && classes.outlineRectOver, animState === 2 && classes.outlineRectOut),
        x: "6",
        y: "9",
        rx: "4",
        ry: "4",
        width: "27",
        height: "23"
    }), /*#__PURE__*/ React.createElement("rect", {
        className: mergeClasses(classes.frontRect, animState === 1 && classes.frontRectOver, animState === 2 && classes.frontRectOut),
        x: "10",
        y: "6",
        rx: "3",
        ry: "3",
        width: "26",
        height: "22"
    }), /*#__PURE__*/ React.createElement("rect", {
        className: mergeClasses(classes.dottedLine, animState === 1 && classes.dottedLineOver),
        x: "7",
        y: "8",
        rx: "4",
        ry: "4",
        width: "26",
        height: "22"
    })));
};
export default SvgCopyAnimated;
